import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import ResponsiveImage from './ResponsiveImage';

const KategorienOverview = () => {
  const { settings } = useSettings();
  const cats = settings?.home_categories || [];
  if (cats.length === 0) return null;

  const placeholderEmoji = (label) => {
    const l = label.toLowerCase();
    if (l.includes('hüpf') || l.includes('huepf')) return '🏰';
    if (l.includes('fun module')) return '🎪';
    if (l.includes('bull')) return '🐂';
    if (l.includes('bungee') || l.includes('trampolin')) return '🤸';
    if (l.includes('food')) return '🍿';
    if (l.includes('eisenbahn')) return '🚂';
    if (l.includes('schminken')) return '🎨';
    if (l.includes('animation')) return '🎭';
    return '✨';
  };

  return (
    <section className="py-6 md:py-10" data-testid="kategorien-overview">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-sky-700">
            Unser vielseitiges Angebot:
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 max-w-6xl mx-auto">
          {cats.map((c, i) => (
            <Link
              key={i}
              to={c.href || '/produkte'}
              className="group block bg-white rounded-2xl shadow-md hover:shadow-xl transition-all overflow-hidden relative"
              data-testid={`category-card-${i}`}
            >
              <div className="aspect-[4/3] bg-sky-100 overflow-hidden">
                {c.image_url ? (
                  <ResponsiveImage
                    src={c.image_url}
                    alt={c.label}
                    sizes="(min-width: 1024px) 14vw, (min-width: 640px) 28vw, 44vw"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-6xl text-sky-300 bg-gradient-to-br from-sky-50 to-sky-100">
                    {placeholderEmoji(c.label)}
                  </div>
                )}
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-sky-700/95 py-1.5 px-3 text-center">
                <span className="text-white font-bold text-sm sm:text-base">{c.label}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KategorienOverview;
